/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_signature = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none

	this.onready = function() {

		$('.js-signature').signature({
			color: 'blue'
		});

		/*
		Save
		*/
		$('.js-signature-save').on('click',function() {

			var _project_id  		= $(this).data('project-id');
			var _signature_type		= $(this).data('signature-type');
			var _signature_from  	= $(this).data('signature-from');

			specific_signature.save(
				_project_id,
				_signature_type,
				_signature_from
			);

		});

		/*
		Reset
		*/
		$('.js-signature-reset').on('click',function() {
			$('.js-signature').signature('clear');
		});
		
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
		
	this.save = function(
		_project_id,
		_signature_type,
		_signature_from
	) {

		var _signature_sign = $('.js-signature').signature('toDataURL');

		/*
		Loading and saving
		*/
		$('.popup .button').hide();

		$.ajax({
			url: globalUrl + '/a/a/signature-save',
			type: "POST",
			data: {
				signature_type  : _signature_type,
				project_id		: _project_id,
				signature_sign	: _signature_sign,
				signature_from	: _signature_from
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Popup: Close
			*/
			popup.close();

			/*
			Set: Signature box with new image
			*/
			$('.js-' + _signature_type + '-signature-box[data-signature-from=' + _signature_from + ']').addClass('active');
			$('.js-' + _signature_type + '-signature-box[data-signature-from=' + _signature_from + ']').css({
				'background-image':'url(' + globalUrl + '/img/uploads/signatures/' + _signature_type + '-' + _project_id + '-' + _signature_from + '.png?time=' +  new Date().getTime() + ')'
			});
		})
		.always(function() {
		});

	};	
		
}).apply(specific_signature); 